export class QnosReq {
    qnos: number[];
    constructor(qnos: number[]) {
        this.qnos = qnos;
    }
}